import React, { useEffect, useState } from 'react'
import { InfoOutlined } from '@material-ui/icons';
import { 
    Button,
    Snackbar,
    withStyles,
    Tooltip,
    TextField,
    Checkbox,
    FormControl,
    FormControlLabel,
    RadioGroup,
    Radio
} from '@material-ui/core'
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_CONFIGURATION } from '../data/constants';
import app from '../authentication/firebaseStart';
import { useAuthContext } from '../authentication/Auth';
import DropdownCustom from '../components/DropdownCustom';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';


const StyledTextField = styled(TextField)`
  display: flex;
  width: 100%;

  input{
  padding: 9px !important;

      &:focus{
        border-color:#2684FF !important;
    }
  }

  & .MuiOutlinedInput-root {
      &.Mui-focused fieldset {
        border-color: #2684FF !important;
      }
    }
`;

export const SVGContainer = styled.div`
    display: flex;
    align-items: center;
    cursor:pointer;
    margin-left: 10px;
    svg{
        font-size: 22px;
        color:#545963;
        &:hover{
        color:#545963;
        }
    }
`;

export const TTBody = styled.p`
    color: #fff;
    font-weight: 400;
    font-size: 14px;
    text-align: left;
    font-family: IBM Plex Sans;
    font-style: normal;
    line-height: 20px;
`;

const MessageInput= styled.textarea`
    box-sizing: border-box;
    display: flex;
    width: 100%;
    height: 95px;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
    background: #FFFFFF;
    border: 1px solid #E0E3E9;
    border-radius: 8px;
    color:#646A78;
    font-weight: 400;
    resize: none;
`;

const ButtonContainer = styled.div`
    display: flex;
    font-family: 'IBM Plex Sans';
`;

const InfoMsg = styled.span`
    color: rgba(0, 0, 0, 0.54);
    margin: 0;
    font-size: 12px;
    margin-top: 3px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    margin-left:70px;
    margin-botton:5px;
    margin-top:1px;
`;

const ErrorMsg = styled.p`
    margin: 0;
    padding-left: 10px;
    font-size: 0.75rem;
    margin-top: 3 px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    color: red;
`;

const Section = styled.div`
    margin-top: 30px;
`

const firestore = app.firestore();

function MlTimeoutPage(props) {
    const [duration, setDuration]= useState(NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION);
    const [isLoading, setIsLoading]=useState(false);
    const [notificationMessage, setNotificationMessage]= useState(NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE);
    const [blockedScreenMsg, setBlockedScreenMsg]= useState(NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.BLOCKED_SCREEN_MESSAGE);
    const [isLock, setIsLock]= useState(NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.LOCK_AFTER_TIMEOUT);
    const [isAudio, setIsAudio] = useState(NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_NOTIFICATION);
    const [audio, setAudio] = useState(NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_TONE);
    const [isVibrate, setIsVibrate] = useState(NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VIBRATE_NOTIFICATION);
    const [vibrate, setVibrate] = useState([NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VIBRATE_DURATION_JSON]);
    const [isLed, setIsLed] = useState(NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.LED_NOTIFICATION);
    const [valuesChanged, setIsValuesChanged]= useState(false)
    const [firebaseData, setFirebaseData] = useState(null);
    const [data, setData]= useState(null)
    const [error, isError]=useState(false);
    const [repeatDuration, setRepeatDuration] = useState([{ label: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.REPEAT_DURATION+" min", value: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.REPEAT_DURATION }]);
    const [customTone, setCustomTone] = useState('');
    const [checkoutEnabled, setCheckoutEnabled] = useState(false);
    const [deviceSound, setDeviceSound] = useState([{ label: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_ON_DEVICE.replace(/\.[^/.]+$/, ""), value: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_ON_DEVICE }]);
    const [volumeLevel, setVolumeLevel] = useState([{ label: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VOLUME_LEVEL+"%", value: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VOLUME_LEVEL }]);

    const context = useAuthContext();
    const companyID = context.currentUser.claims.companyID;
    const { t } = useTranslation();
    const vibrateType= NOTIFICATION_CONFIGURATION.VIBRATE_OPTION;
    const deviceSoundArr = NOTIFICATION_CONFIGURATION.DEVICE_SOUND_LIST;
    const volumeLevelArr = NOTIFICATION_CONFIGURATION.VOLUME_LEVEL_LIST;
    const replayIntervalArr = NOTIFICATION_CONFIGURATION.REPEAT_INTERVAL;
    

    useEffect(()=> {
        fetchData();
        fetchCheckoutState();
    },[]);

    // checking error status
    useEffect(() => {
        if(!isDurationValid()
            || (notificationMessage.trim().length == 0 || notificationMessage.length > NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE_MAX_LENGTH) 
            || (blockedScreenMsg.trim().length == 0 || blockedScreenMsg.length > NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE_MAX_LENGTH) 
            || isAudio == NOTIFICATION_CONFIGURATION.NOTIFICATION.ENABLE && audio == 2 && customTone?.trim().length == 0
            || repeatDuration.length && repeatDuration[0].value > duration
        ){
            isError(true);
        }
        else{
            isError(false);
        }
    }, [duration, notificationMessage, blockedScreenMsg, customTone, isAudio, audio, repeatDuration]);

    useEffect(() => {
        for(let i=0; i<replayIntervalArr.length; i++){
            if(replayIntervalArr[i].value > duration){
                replayIntervalArr[i]["isdisabled"] = true;
            }
            else{
                replayIntervalArr[i]["isdisabled"] = false;
            }
        }
    }, [duration]);

    async function fetchCheckoutState(){
        try{
            const checkoutState = (
                await firestore
                .collection('tenants')
                .doc(companyID)
                .collection('Configuration')
                .doc('AppSettings')
                .get() 
            ).data();

            if(checkoutState && checkoutState.checkinStatus){
                setCheckoutEnabled(true);
            }
            else{
                setCheckoutEnabled(false);
            }
        }
        catch(err){
            console.log(err);
            setCheckoutEnabled(false);
        }
    }

    async function fetchData() {
        setIsLoading(true);
        try{
            const checkData = (
                await firestore
                .collection('tenants')
                .doc(companyID)
                .collection('Configuration')
                .doc('AppSettings')
                .collection("DLRSettings")
                .doc("DLRNotification")
                .get()
            ).data();
            if(checkData){
                setFirebaseData(checkData);
                setData(checkData)
                setDuration((typeof checkData.timeoutDuration!== typeof undefined) ? checkData.timeoutDuration: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION)
                setIsLock((typeof checkData.lockAfterTimeout!== typeof undefined)? checkData.lockAfterTimeout: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.LOCK_AFTER_TIMEOUT)
                setNotificationMessage((typeof checkData.message!== typeof undefined) ? checkData.message: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE)
                setBlockedScreenMsg((typeof checkData.messageOnBlockedScreen!== typeof undefined)? checkData.messageOnBlockedScreen: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.BLOCKED_SCREEN_MESSAGE)
                setIsAudio((typeof checkData.audioNotification!==typeof undefined)?checkData.audioNotification:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_NOTIFICATION)
                setAudio((typeof (checkData.audioTone)!== typeof undefined)? checkData.audioTone: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_TONE)
                setCustomTone((typeof checkData.audioCustomTone!==typeof undefined)? checkData.audioCustomTone: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.CUSTOM_TONE);
                setDeviceSound(getDeviceAudio((typeof checkData.audioFileOnDevice!==typeof undefined)? checkData.audioFileOnDevice: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_ON_DEVICE));
                setVolumeLevel(getVolumeLevel((typeof checkData.volumeLevel!==typeof undefined)? checkData.volumeLevel: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VOLUME_LEVEL));
                setIsLed((typeof checkData.ledNotification!==typeof undefined)? checkData.ledNotification: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.LED_NOTIFICATION);
                setIsVibrate((typeof checkData.vibrateNotification!==typeof undefined)? checkData.vibrateNotification: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VIBRATE_NOTIFICATION)
                setVibrate(getVibrateDuration(typeof checkData.vibrateDuration!==typeof undefined? checkData.vibrateDuration: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VIBRATE_DURATION));
                setRepeatDuration(getRepeatInterval((typeof checkData.repeatDuration!==typeof undefined)? checkData.repeatDuration: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.REPEAT_DURATION));
            }
            else{
                console.log("No data found");
                const defaultData = {
                    timeoutDuration: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION,
                    lockAfterTimeout: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.LOCK_AFTER_TIMEOUT,
                    message: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE,
                    messageOnBlockedScreen: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.BLOCKED_SCREEN_MESSAGE,
                    audioNotification:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_NOTIFICATION,
                    audioTone:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_TONE,
                    audioCustomTone:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.CUSTOM_TONE,
                    audioFileOnDevice:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_ON_DEVICE,
                    volumeLevel:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VOLUME_LEVEL,
                    ledNotification:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.LED_NOTIFICATION,
                    vibrateNotification:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VIBRATE_NOTIFICATION,
                    vibrateDuration: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VIBRATE_DURATION,
                    repeatDuration:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.REPEAT_DURATION
                }
                setFirebaseData(defaultData);
                setData(defaultData)
            }
            setIsLoading(false);
        }
        catch(err){
            console.log(err);
        }
    }

    function handleNotificationMessage(e) {
        setNotificationMessage(e);
        let temp= JSON.parse(JSON.stringify(data))
        temp.message=e;
        if(e && e.trim().length > 0 && e.length <= NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE_MAX_LENGTH){
            setData(temp);
            if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
                setIsValuesChanged(true);
            }else{
                setIsValuesChanged(false)
            }
        }
    }

    function handleBlockedScreenMsg(e) {
        setBlockedScreenMsg(e);
        let temp= JSON.parse(JSON.stringify(data))
        temp.messageOnBlockedScreen = e;
        if(e && e.trim().length > 0 && e.length <= NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE_MAX_LENGTH){
            setData(temp);
            if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
                setIsValuesChanged(true);
            }else{
                setIsValuesChanged(false)
            }
        }
    }

    function handleLockStatus(e){
        let temp= JSON.parse(JSON.stringify(data))
        if(e){
            setIsLock(NOTIFICATION_CONFIGURATION.NOTIFICATION.ENABLE)
            temp.lockAfterTimeout=NOTIFICATION_CONFIGURATION.NOTIFICATION.ENABLE;
        }
        else{
            setIsLock(NOTIFICATION_CONFIGURATION.NOTIFICATION.DISABLE)
            temp.lockAfterTimeout=NOTIFICATION_CONFIGURATION.NOTIFICATION.DISABLE;
        }
        setData(temp)
        if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
            if(!valuesChanged )
                setIsValuesChanged(true);
        }else{
            setIsValuesChanged(false)
        }
    }

    function handleAudioToggle(e) {
        let temp= JSON.parse(JSON.stringify(data))
        if(e.target.checked){
            setIsAudio(NOTIFICATION_CONFIGURATION.NOTIFICATION.ENABLE)
            temp.audioNotification=NOTIFICATION_CONFIGURATION.NOTIFICATION.ENABLE
        }
        else{
            setAudio(parseInt(firebaseData.audioTone));
            setCustomTone(firebaseData.audioCustomTone);
            setDeviceSound(getDeviceAudio(firebaseData.audioFileOnDevice));
            setVolumeLevel(getVolumeLevel(firebaseData.volumeLevel));

            temp.audioTone = firebaseData.audioTone;
            temp.audioCustomTone = firebaseData.audioCustomTone;
            temp.audioFileOnDevice = firebaseData.audioFileOnDevice;
            temp.volumeLevel = firebaseData.volumeLevel;

            setIsAudio(NOTIFICATION_CONFIGURATION.NOTIFICATION.DISABLE);
            temp.audioNotification=NOTIFICATION_CONFIGURATION.NOTIFICATION.DISABLE;
        }
        setData(temp)
        if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
            if(!valuesChanged )
                setIsValuesChanged(true);
        }else{
            setIsValuesChanged(false)
        }
    }

    function onChangeAudioType(e) {
        let temp= JSON.parse(JSON.stringify(data))
        setAudio(parseInt(e.target.value))
        temp.audioTone=parseInt(e.target.value);
        setData(temp);
        if(e.target.value == 0){
            setCustomTone(firebaseData.audioCustomTone);
            setDeviceSound(getDeviceAudio(firebaseData.audioFileOnDevice));

            temp.audioCustomTone = firebaseData.audioCustomTone;
            temp.audioFileOnDevice = firebaseData.audioFileOnDevice;
        }
        else if(e.target.value == 1){
            setCustomTone(firebaseData.audioCustomTone);
            temp.audioFileOnDevice = firebaseData.audioFileOnDevice;
        }
        else if(e.target.value == 2){
            setCustomTone(firebaseData.audioCustomTone);
            temp.audioCustomTone = firebaseData.audioCustomTone;
        }
        if(JSON.stringify(firebaseData) != JSON.stringify(temp)){
            if(!valuesChanged)
                setIsValuesChanged(true);
        }else{
            setIsValuesChanged(false)
        }
    }

    const onDeviceTrackerSoundChange = (audio) => {
        let label = audio.replace(/\.[^/.]+$/, "");
        let value = audio;
        setDeviceSound([{ label: label, value: value }]);
        let temp= JSON.parse(JSON.stringify(data))
        temp.audioFileOnDevice = audio;
        setData(temp);
        if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
            if(!valuesChanged )
                setIsValuesChanged(true);
        }else{
            setIsValuesChanged(false)
        }
    }

    function changeCustomTone(e) {
        let temp= JSON.parse(JSON.stringify(data))
        setCustomTone(e.target.value)
        temp.audioCustomTone=e.target.value;
        setData(temp);
        if(e.target.value.length == 0){
            setIsValuesChanged(false)
        }
        else{
            if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
                if(!valuesChanged )
                    setIsValuesChanged(true);
            }else{
                setIsValuesChanged(false)
            }
        }
    }

    const onVolumeLevelChange = (volumeLevelValue) => {
        setVolumeLevel([ { label: volumeLevelValue+'%', value: volumeLevelValue }]);
        let temp= JSON.parse(JSON.stringify(data))
        temp.volumeLevel = volumeLevelValue;
        setData(temp);
        if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
            if(!valuesChanged )
                setIsValuesChanged(true);
        }else{
            setIsValuesChanged(false)
        }
    }

    function onChangeVibrationType(e){
        let temp= JSON.parse(JSON.stringify(data))
        setVibrate(getVibrateDuration(parseInt(e.target.value)))
        temp.vibrateDuration=parseInt(e.target.value);
        setData(temp)
        if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
            if(!valuesChanged )
                setIsValuesChanged(true);
        }else{
            setIsValuesChanged(false)
        }
    }

    const handleDurationChanegs = (value) => {
        value = value.length? inputFieldNumberOnly(value) : value;
        let temp= JSON.parse(JSON.stringify(data))
        setDuration(value);
        temp.timeoutDuration = value;
        setData(temp)
        if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
            if(!valuesChanged ){
                setIsValuesChanged(true);
            }
        }
        else{
            setIsValuesChanged(false)
        }   
    }

    const handleRepeatValueChange = value => {
        setRepeatDuration(getRepeatInterval(value));

        let temp= JSON.parse(JSON.stringify(data))
        temp.repeatDuration=parseInt(value);
        setData(temp)
        if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
            if(!valuesChanged ){
                setIsValuesChanged(true);
            }
        }
        else{
            setIsValuesChanged(false)
        }      
    }

    useEffect(() => {
        console.log("valuesChanged ",valuesChanged);
    }, [valuesChanged])

    useEffect(() => {
        console.log("error ",error);
    }, [error])

    const handleVibrateToggleChange = (e) => {
        let temp= JSON.parse(JSON.stringify(data))
        if(e.target.checked){
            setIsVibrate(NOTIFICATION_CONFIGURATION.NOTIFICATION.ENABLE)
            temp.vibrateNotification=NOTIFICATION_CONFIGURATION.NOTIFICATION.ENABLE
        }
        else{
            temp.vibrateDuration = firebaseData.vibrateDuration;
            setIsVibrate(NOTIFICATION_CONFIGURATION.NOTIFICATION.DISABLE)
            temp.vibrateNotification=NOTIFICATION_CONFIGURATION.NOTIFICATION.DISABLE
        }
        setData(temp);
        if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
            if(!valuesChanged ) setIsValuesChanged(true);
        }
        else{
            setIsValuesChanged(false)
        }
    }

    const handleLedToggleChange = (e) => {
        let temp= JSON.parse(JSON.stringify(data));
        if(e.target.checked){
            setIsLed(NOTIFICATION_CONFIGURATION.NOTIFICATION.ENABLE)
            temp.ledNotification=NOTIFICATION_CONFIGURATION.NOTIFICATION.ENABLE
        }
        else{
            setIsLed(NOTIFICATION_CONFIGURATION.NOTIFICATION.DISABLE)
            temp.ledNotification=NOTIFICATION_CONFIGURATION.NOTIFICATION.DISABLE
        }
        setData(temp);
        if(JSON.stringify(firebaseData)!==JSON.stringify(temp)){
            if(!valuesChanged ) setIsValuesChanged(true);
        }
        else{
            setIsValuesChanged(false)
        }
    }

    async function onClickResetBtn() {
        setIsLoading(true);
        const finalData = {
            timeoutDuration: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION,
            lockAfterTimeout: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.LOCK_AFTER_TIMEOUT,
            message: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE,
            messageOnBlockedScreen: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.BLOCKED_SCREEN_MESSAGE,
            audioNotification:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_NOTIFICATION,
            audioTone:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_TONE,
            audioCustomTone:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.CUSTOM_TONE,
            audioFileOnDevice:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.AUDIO_ON_DEVICE,
            volumeLevel:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VOLUME_LEVEL,
            ledNotification:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.LED_NOTIFICATION,
            vibrateNotification:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VIBRATE_NOTIFICATION,
            vibrateDuration: NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.VIBRATE_DURATION,
            repeatDuration:NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.REPEAT_DURATION
        }
        try{
            await firestore
                .collection('tenants')
                .doc(companyID)
                .collection('Configuration')
                .doc('AppSettings')
                .collection("DLRSettings")
                .doc("DLRNotification")
                .update(finalData)

            props.serverResponse.current = {status:true, msg: t('mlTimeoutPage.success') };
            props.setSnackbarOpen(true);
        }
        catch(err){
            console.log(err);
            props.serverResponse.current = {status:false, msg: err };
            props.setSnackbarOpen(true);
        }
        fetchData()
        setIsLoading(false);
        setIsValuesChanged(false)
        setIsValuesChanged(false);
        props.setSnackbarOpen(true);
    }

    function onClickCancelBtn() {
        fetchData();
        setIsValuesChanged(false)
    }

    async function onClickSaveBtn() {
        setIsLoading(true)
        const finalData={
            timeoutDuration: Number(duration),
            lockAfterTimeout: isLock,
            message: notificationMessage,
            messageOnBlockedScreen: blockedScreenMsg,
            audioNotification: isAudio,
            audioTone: audio,
            audioCustomTone: customTone,
            audioFileOnDevice: deviceSound && deviceSound.length ? deviceSound[0].value : "",
            volumeLevel: data.volumeLevel,
            ledNotification: isLed,
            vibrateNotification: isVibrate,
            vibrateDuration: data.vibrateDuration,
            repeatDuration: repeatDuration && repeatDuration.length ? repeatDuration[0].value : ""
        }
        if(!NOTIFICATION_CONFIGURATION.NOTIFICATION[isAudio]){
            finalData.audioCustomTone = firebaseData.audioCustomTone;
        }

        try{
            await firestore
                .collection('tenants')
                .doc(companyID)
                .collection('Configuration')
                .doc('AppSettings')
                .collection("DLRSettings")
                .doc("DLRNotification")
                .update(finalData);

            props.serverResponse.current = {status:true, msg: t('mlTimeoutPage.success') };
            props.setSnackbarOpen(true);
        }
        catch(err){
            console.log(err);
            props.serverResponse.current = {status:false, msg: err };
            props.setSnackbarOpen(true);
        }
        setIsLoading(false);
        setFirebaseData(data)
        setIsValuesChanged(false);
    }

    /**
     * provide restriction on input field allow only numeric value 
     * @param {String} value take input values
     * @returns only number
     */
    const inputFieldNumberOnly = value => {
        const onlyNums = value.replace(/[^0-9]/g, '');
        if (onlyNums.length < 10) {
            return onlyNums
        } else if (onlyNums.length === 10) {
            const number = onlyNums.replace(
                /(\d{3})(\d{3})(\d{4})/,
                '($1) $2-$3'
            );
            return number;
        }
    }

    /**
     * function handle max and min value limit for input field
     * @param {Object} e event object of element
     * @param {number} maxVal maximum value can be accepted
     * @param {number} minVal minimum value can be accepted
     */
    const handleMax_MinValue = (e, maxVal, minVal) => {
        e.target.value = Math.min(maxVal, parseInt(e.target.value)).toString();
    }

    const QuestionTT = withStyles((theme) => ({
        tooltip: {
            backgroundColor: '#000000',
            color: theme.typography.pxToRem(14),
            maxWidth: 300,
            border: '1px solid #000000'
        },
        arrow: {
            color: '#000000'
        }
    }))(Tooltip);

    const getCustomToneErrorMsg = () => {
        if(NOTIFICATION_CONFIGURATION.NOTIFICATION[isAudio] && audio == 2){
            if(customTone?.trim().length == 0)
                return (<ErrorMsg data-testid="customToneBlannkError">{t('mlTimeoutPage.customToneErrorMsg')}</ErrorMsg>);
            else return null;
        }
    }

    const getRepeatIntervalErrorMsg = () => {
        if(repeatDuration.length && repeatDuration[0].value > duration)
            return (<ErrorMsg data-testid="repeatIntervalError">{t('mlTimeoutPage.repeatIntervalErrorMsg')}</ErrorMsg>);
        else return null;
    }

    const getDurationErrorMsg = () => {
        if(duration < NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MIN)
            return (<ErrorMsg data-testid="durationMinError">{t('mlTimeoutPage.atRiskDurationMinError')}</ErrorMsg>);
        else if(duration > NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MAX)
            return (<ErrorMsg data-testid="durationMaxError">{t('mlTimeoutPage.atRiskDurationMaxError')}</ErrorMsg>);
        else return null;
    }

    const reformDurationValue = (value) => isNaN(duration) || duration == "" ? NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MIN : parseInt(duration) + value;

    const isDurationValid = () => !(isNaN(duration) || duration < NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MIN || duration> NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MAX)

    const getDeviceAudio = audioValue => [{ label: audioValue?.replace(/\.[^/.]+$/, ""), value: audioValue }];

    const getVolumeLevel = volumeLevelValue => [ { label: volumeLevelValue+'%', value: volumeLevelValue }];

    const getVibrateDuration = duration => NOTIFICATION_CONFIGURATION.VIBRATE_OPTION.filter(int => int.value == duration);

    const getRepeatInterval = interval => NOTIFICATION_CONFIGURATION.REPEAT_INTERVAL.filter(int => int.value == interval);

    return(
        <div style={{ width: "750px", marginLeft: "24px" }}>
            <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=IBM Plex Sans"></link>
            <p className="play-sound-desciption" data-testid='pageTitle'>{t('mlTimeoutPage.notificationDetails')}</p>

                        {/* at Risk Duration Section*/}
            <Section>
                <FormControl fullWidth>
                    <p id="replay-interval-label" className="playsound-label" data-testid="atRiskDurationTitle">{t('mlTimeoutPage.atRiskDurationTitle')}</p>
                    <p className="play-sound-desciption" data-testid="atRiskDurationDescription">{t('mlTimeoutPage.atRiskDurationDescription')}</p>
                    <div style={{ display: 'flex', flexDirection: "row", width: "50%" }}>
                        <Button 
                            data-testid="durationInputDcr"
                            variant="outlined"
                            onClick={() => {if (duration > NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MIN){handleDurationChanegs(reformDurationValue(-1))}}}
                            disabled={ duration <= NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MIN ? true : false }
                        >
                            <RemoveIcon></RemoveIcon>
                        </Button>
                        <TextField
                            style={{ margin: "0 5px" }}
                            fullWidth
                            value={duration}
                            variant="outlined"
                            id='durationInput'
                            data-testid='durationInput'
                            inputProps={{
                                style: {
                                    height: 5,
                                    textAlign: 'center',
                                }
                            }}
                            inputstyle={{textAlign: 'center', cursor: 'none' }}
                            onChange={e => handleDurationChanegs(e.target.value)}
                            onInput = { e => handleMax_MinValue(e, NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MAX, NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MIN) }
                        />
                        <Button 
                            data-testid="durationInputInc"
                            variant="outlined"
                            onClick={() => {if (duration < NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MAX)handleDurationChanegs(reformDurationValue(1))}}
                            disabled={duration >= NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.TIMEOUT_DURATION_MAX ? true : false}
                        >
                            <AddIcon></AddIcon>
                        </Button>
                    </div>
                    { getDurationErrorMsg() }
                </FormControl>
            </Section>

                        {/* Lock Device Section */}
            <Section>
                <FormControlLabel 
                    control= {
                        <Checkbox
                            color="primary"
                            style={{"paddingLeft":"0"}}
                            id='lockActivation'
                            data-testid='lockActivation'
                            checked={NOTIFICATION_CONFIGURATION.NOTIFICATION[isLock]}
                            onChange={(e) =>handleLockStatus(e.target.checked)}
                            disabled={!checkoutEnabled}
                        />
                    }
                    label={(<p className="playsound-label">{t('mlTimeoutPage.lockDeviceTitle')}</p>)}
                />
                {
                    !checkoutEnabled ?
                    <>
                        <span style={{marginLeft:"40px", marginTop: "8px",  position:"absolute"}}>
                            <InfoOutlined style={{color: "#929AA9"}}/>
                        </span>
                        <InfoMsg>{t('mlTimeoutPage.disableCheckoutWarning')}</InfoMsg>
                    </> : null
                }
                <p className="play-sound-desciption" data-testid='subPageTitle' style={{ marginLeft: "24px" }}>{t('mlTimeoutPage.lockDeviceDescription')}</p>
            </Section>
            
                        {/* message on locked screen section */}
            <Section>
                <p className="playsound-label" data-testid="messageTitle">{t('mlTimeoutPage.messageTitle')}</p>
                <p data-testid='messageDescription' className="play-sound-desciption" style={{ display: "flex" }}>
                    {t('mlTimeoutPage.messageDescription')}
                    <QuestionTT arrow title={<>
                            <TTBody>{t('mlTimeoutPage.messageTooltip')}</TTBody>
                        </>}
                    >
                        <SVGContainer>
                            <HelpOutlineIcon />
                        </SVGContainer>
                    </QuestionTT>
                </p>
                <MessageInput 
                    id='blockedScreenMsg' 
                    data-testid='blockedScreenMsgInput' 
                    error={true}
                    value={blockedScreenMsg}
                    type='text'
                    onChange={(e)=>handleBlockedScreenMsg(e.target.value)}
                    style={
                        (blockedScreenMsg.trim().length===0 || blockedScreenMsg.length > NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE_MAX_LENGTH) ? 
                        {"borderColor":"red","marginRight":"300px"}:{"borderColor":"#E0E3E9","marginRight":"300px"}}
                />
                {(blockedScreenMsg.trim().length==0)&&<span data-testid='blockedScreenMsgInput-errorTxt' style={{"color":"red", fontSize: "13px"}}>{t('mlTimeoutPage.messageErrorMsg')}</span>}
                {(blockedScreenMsg.length > NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE_MAX_LENGTH)&&<span data-testid='blockedScreenMsgInput-errorTxt' style={{"color":"red", fontSize: "13px"}}>{t('mlTimeoutPage.messageLengthExceedErrorMsg')}</span>}
            </Section>
            
                        {/* message on unlocked screen section */}
            <Section>
                <p className="playsound-label" data-testid="LockedMessageTitle">{t('mlTimeoutPage.LockedMessageTitle')}</p>
                <p data-testid='LockedMessageDescription' className="play-sound-desciption" style={{ display: "flex" }}>
                    {t('mlTimeoutPage.LockedMessageDescription')}
                    <QuestionTT arrow title={<>
                        <TTBody>{t('mlTimeoutPage.LockedMessageTooltip')}</TTBody>
                    </>}>
                        <SVGContainer>
                            <HelpOutlineIcon />
                        </SVGContainer>
                    </QuestionTT>
                </p>
                <MessageInput 
                    id='NotificationMessage'
                    data-testid='NotificationMessageInput'
                    error={true}
                    value={notificationMessage}
                    type='text'
                    onChange={(e)=>handleNotificationMessage(e.target.value)}
                    style={
                        (notificationMessage.trim().length===0 || notificationMessage.length > NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE_MAX_LENGTH) ? 
                        {"borderColor":"red","marginRight":"300px"}:{"borderColor":"#E0E3E9","marginRight":"300px"}}
                />
                {(notificationMessage.trim().length==0)&&<span data-testid='NotificationMessageInput-errorTxt' style={{"color":"red", fontSize: "13px"}}>{t('mlTimeoutPage.messageErrorMsg')}</span>}
                {(notificationMessage.length > NOTIFICATION_CONFIGURATION.DEFAULT_VALUES.MESSAGE_MAX_LENGTH)&&<span data-testid='NotificationMessageInput-errorTxt' style={{"color":"red", fontSize: "13px"}}>{t('mlTimeoutPage.messageLengthExceedErrorMsg')}</span>}
            </Section>

                        {/* Audio Section */}
            <Section>
                <FormControlLabel 
                    control= {
                        <Checkbox
                            color="primary"
                            style={{"paddingLeft":"0"}}
                            id='audioSwitch'
                            data-testid='audioSwitch'
                            checked={ NOTIFICATION_CONFIGURATION.NOTIFICATION[isAudio] }
                            onChange={ handleAudioToggle }
                        />
                    }
                    label={t("mlTimeoutPage.audio")}
                />
                <div className="playsound-radio-format-control">
                    <FormControl component="fieldset" fullWidth>
                        <RadioGroup id='play-sound' aria-label="play-sound-type" name="play-sound-type" data-testid="audioOption"
                            value={audio}
                            onChange={(e) => {onChangeAudioType(e)}}
                        >
                            <FormControlLabel value={0}
                                control={
                                    <Radio color="primary" id='system-default' data-testid="systemDefault" disabled={!NOTIFICATION_CONFIGURATION.NOTIFICATION[isAudio]}/>
                                }
                                label={t('mlTimeoutPage.systemDefault')}
                            />
                            <FormControlLabel value={1}
                                control={

                                    <Radio color="primary" id='device-tracker-sound' data-testid="dtrkSound" disabled={!NOTIFICATION_CONFIGURATION.NOTIFICATION[isAudio]}/>
                                }
                                label={t('mlTimeoutPage.dtrkSound')}
                                
                            />
                            <div data-testid="dtrkSoundListDiv" className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" style={{ paddingLeft: 30, width: "50%" }}>
                                <label htmlFor="dtrkSound" style={{ display: "none" }}>Dtrk Sound List Dropdown</label>
                                <DropdownCustom
                                    name="dtrkSound"
                                    id="dtrkSoundList"
                                    selectVal={deviceSound}
                                    selectOpts={deviceSoundArr}
                                    onChange={(e) => onDeviceTrackerSoundChange(e.target.value)}
                                    isDisabled={audio === 1 ? false : true}
                                />
                            </div>
                            <FormControlLabel value={2}
                                control={
                                    <Radio color="primary" id='custom-tone' data-testid="soundOnFile" disabled={!NOTIFICATION_CONFIGURATION.NOTIFICATION[isAudio]}/>
                                }
                                label={t('mlTimeoutPage.soundOnFile')}
                            />
                            <div className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" style={{ paddingLeft: 30 }}>
                                <StyledTextField
                                    data-testid="customeTone"
                                    value = {customTone}
                                    variant="outlined"
                                    onChange={(e)=> changeCustomTone(e)}
                                    disabled={ NOTIFICATION_CONFIGURATION.NOTIFICATION[isAudio] && audio === 2 ? false : true }
                                    placeholder={t('mlTimeoutPage.customTonePlaceholder')}
                                    style={{ width: "52%"}}
                                />
                                { getCustomToneErrorMsg() }
                            </div>
                        </RadioGroup>
                    </FormControl>
                </div>

                <div className="playsound-format-control">
                    <FormControl fullWidth>
                        <label htmlFor="volume" id="volume-level-tag" className="playsound-label" data-testid="volumeLevelTitle">{t('mlTimeoutPage.volumeLevelTitle')}</label>
                        <div  data-testid="volumeLevelDiv" className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" style={{ width: "50%" }}>
                            <DropdownCustom
                                name="volume"
                                selectVal={volumeLevel}
                                id='volumeLevel'
                                selectOpts={volumeLevelArr}
                                onChange={(e) => onVolumeLevelChange(e.target.value)}
                                label={t('mlTimeoutPage.volumeLevelTitle')}
                                isDisabled={!NOTIFICATION_CONFIGURATION.NOTIFICATION[isAudio]}
                            />
                        </div>

                    </FormControl>

                </div>
            </Section>

                        {/* Led Section */}
            <Section>
                <FormControlLabel 
                    control= {
                        <Checkbox
                        color="primary"
                        style={{"paddingLeft":"0"}}
                        id='ledSwitch'
                        data-testid='ledSwitch'
                        checked={NOTIFICATION_CONFIGURATION.NOTIFICATION[isLed]}
                        onChange={ handleLedToggleChange }
                    />
                    }
                    label={t("mlTimeoutPage.led")}
                />
            </Section>

                        {/* Vibration section */}
            <Section style={{ marginTop: 0 }}>
                <FormControlLabel 
                    control= {
                        <Checkbox
                            color="primary"
                            style={{"paddingLeft":"0"}}
                            id='vibrateSwitch'
                            data-testid='vibrateSwitch'
                            checked={NOTIFICATION_CONFIGURATION.NOTIFICATION[isVibrate]}
                            onChange={ handleVibrateToggleChange }
                        />
                    }
                    label={t("mlTimeoutPage.vibrate")}
                />
                <div data-testid="vibrateOptionDiv" className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" style={{ paddingLeft: 30, width: "50%" }}>
                    <label htmlFor="vibrateOptionLabel" style={{ display: "none" }}>Vibration Duration</label>
                    <DropdownCustom
                        id="vibrateOption"
                        name="vibrateOptionLabel"
                        selectVal={vibrate}
                        selectOpts={vibrateType}
                        onChange={(e) => onChangeVibrationType(e)}
                        isDisabled={ !NOTIFICATION_CONFIGURATION.NOTIFICATION[isVibrate] }
                    />
                </div>
            </Section>

                        {/* repeat Interval section */}
            <Section>
                <FormControl  fullWidth>
                    <label 
                        htmlFor="repeatSwitchLabel" 
                        id="replay-interval-label" 
                        className="playsound-label" 
                        data-testid="repeatIntervalTitle"
                        style={{ marginLeft: "-8px" }}
                    >{t("mlTimeoutPage.repeatIntervalTitle")}</label>
                    <p 
                        className="play-sound-desciption" 
                        data-testid="repeatIntervalDescription"
                        style={{ marginLeft: "28px" }}
                    >{t("mlTimeoutPage.repeatIntervalDescription")}</p>
                    <div 
                        data-testid='repeatSwitchDiv' 
                        className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" 
                        style={{ width: "50%", marginLeft: "28px" }}
                    >
                        <DropdownCustom
                            selectVal={repeatDuration}
                            selectOpts={replayIntervalArr}
                            id="repeatSwitch"
                            name="repeatSwitchLabel"
                            onChange={(e) => handleRepeatValueChange(e.target.value)}
                        />
                    </div>
                    { getRepeatIntervalErrorMsg() }
                </FormControl>
            </Section>

                        {/* button section */}
            <Section>
                <ButtonContainer>
                    <Button
                        id="resetBtn"
                        data-testid="resetBtn"
                        onClick={onClickResetBtn}
                        style={{
                            textTransform: "none",
                            marginLeft: '0px',
                            border: "1px solid #D70015",
                            fontWeight:"500", 
                            background: "white",
                            color:"#D70015",
                            marginRight:"auto"
                        }}
                    >
                        {t('workFlow.button.resetDefault')}   
                    </Button>
                    <Button
                        id="cancelBtn"
                        data-testid="cancelBtn"
                        disabled={!valuesChanged || error}
                        onClick={() => onClickCancelBtn()}
                        style={{
                            textTransform: "none",
                            borderRadius: '5px',
                            marginLeft: '0px', 
                            background: (!valuesChanged || error) ? '#E8EBF1' : '#f5f1f1', 
                            color: (!valuesChanged || error) ? '#929AA9' : 'black',
                            fontWeight:"500",
                            padding: "12px 24px"
                        }}
                    >
                        {t('workFlow.button.cancel')}
                    </Button>
                    <Button
                        id="saveBtn"
                        data-testid="saveBtn"
                        disabled={!valuesChanged || error}
                        onClick={onClickSaveBtn}
                        style={{ 
                            textTransform: "none",
                            borderRadius: '5px',
                            fontWeight:"500",
                            backgroundColor: (!valuesChanged || error) ? '#E8EBF1' : '#0073E6', 
                            width: "150px", 
                            height: "48px",
                            marginLeft:"10px", 
                            color: (!valuesChanged || error) ? '#929AA9' : "white"
                        }}
                    >
                        {t('mlTimeoutPage.saveChanges')}
                    </Button>
                </ButtonContainer>
            </Section>
        </div>
    )
}
export default MlTimeoutPage;